import type { CSSProperties } from 'react';

import './anel.css';

export type PropsAnel = {
  valor: number;
  total: number;
  /** O que se conta: "horas", "publicações", "estudos". Entra no rótulo
   *  acessível junto do valor e do total. */
  rotulo: string;
  /** Aresta desejada em px. É teto, não medida fixa: o anel nunca passa da
   *  largura disponível. */
  tamanho?: number;
};

// Números inteiros saem exatos; fracionários vão com vírgula, que é o
// separador decimal do português.
function formata(n: number): string {
  return Number.isInteger(n)
    ? String(n)
    : n.toLocaleString('pt-BR', { maximumFractionDigits: 1 });
}

const RAIO = 44;
const CIRCUNFERENCIA = 2 * Math.PI * RAIO;

export function Anel({ valor, total, rotulo, tamanho = 96 }: PropsAnel) {
  // Total zero, valor negativo e valor acima da meta são os três casos que
  // quebrariam o desenho; todos morrem aqui, não no SVG.
  const bruta = total > 0 ? valor / total : 0;
  const fracao = Number.isFinite(bruta) ? Math.min(1, Math.max(0, bruta)) : 0;
  const porcentagem = Math.round(fracao * 100);
  return (
    <svg
      className="ds-anel"
      role="img"
      aria-label={`${formata(valor)} de ${formata(total)} ${rotulo}`}
      data-porcentagem={String(porcentagem)}
      viewBox="0 0 100 100"
      style={{ '--ds-anel-tamanho': `${tamanho}px` } as CSSProperties}
    >
      {/* O desenho inteiro é decorativo: quem descreve é o `aria-label`. */}
      <g aria-hidden="true">
        <circle className="ds-anel__trilho" cx="50" cy="50" r={RAIO} />
        <circle
          className="ds-anel__arco"
          cx="50"
          cy="50"
          r={RAIO}
          strokeDasharray={CIRCUNFERENCIA}
          strokeDashoffset={CIRCUNFERENCIA * (1 - fracao)}
        />
      </g>
    </svg>
  );
}
